var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.5C4 0.223858 4.22386 0 4.5 0H5.5C5.77614 0 6 0.223858 6 0.5V2.00001H14V0.5C14 0.223858 14.2239 0 14.5 0H15.5C15.7761 0 16 0.223858 16 0.5V2.00001H16.5C18.433 2.00001 20 3.56701 20 5.50001V16.5C20 18.433 18.433 20 16.5 20H3.5C1.56701 20 4.12323e-06 18.433 0 16.5V5.50001C0 3.56701 1.567 2.00001 3.5 2.00001H4V0.5ZM2 16.5V7H18V16.5C18 17.3284 17.3284 18 16.5 18H3.5C2.67158 18 2 17.3284 2 16.5ZM11.5 12C11.2239 12 11 12.2239 11 12.5V15.5C11 15.7761 11.2239 16 11.5 16H15.5C15.7761 16 16 15.7761 16 15.5V12.5C16 12.2239 15.7761 12 15.5 12H11.5Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/iconCalendar.a75598f924aad8238cfe90fb392e088a.svg";
export { ForwardRef as ReactComponent };